import { HttpHeaders } from '@angular/common/http';

export const COLUMN_NAME_RESULT_DATA_TABLE = {
  ACTION: 'action',
  SYSTEM_WORKFLOW: 'systemworkflow',
};

export const ROW_SELECTION_RESULT_DATA_TABLE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
} as const;

export type RowSelectionType = 'single' | 'multiple';

export type VehicleType = 'truck' | 'trailer';

export const BUTTON_CLICK = {
  SAVE: 'Save',
  EDIT: 'Edit',
  DELETE: 'Delete',
  RESET: 'Reset',
};

export const UploadMode = {
  ADD: 'add',
  REPLACE: 'replace',
  APPEND: 'append',
};

export const UploadMode_Name = {
  REPLACE: 'Replace',
  APPEND: 'Append',
};

export const WorkflowCategory = {
  ORDER: 'Order',
  SHIPMENT: 'Shipment',
};

export const RETURN_ALL = '*';

export const INPUT_TYPE = {
  Date: 'DATE',
  Date_Time: 'DATETIME',
  Text_Field: 'TEXTFIELD',
  Dropdown: 'DROPDOWN',
  Editable_Dropdown: 'EDITABLEDROPDOWN',
  Checkbox: 'CHECKBOX',
  Checkbox_Chr: 'CHECKBOX_CHR',
  Dropdown_Mc: 'DROPDOWN_MC',
  Time_24: 'TIME24',
  Dropdown_Ms: 'DROPDOWN_MS',
};

export const PRIORITY = {
  HIGH: 'HIGH',
  LOW: 'LOW',
};

export const CONTENT_TYPE = {
  JSON: 'application/json',
  OCTET_STREAM: 'application/octet-stream',
};

export const ACCEPT_ALL_HEADER = new HttpHeaders({
  Accept: '*/*',
});

export const MASS_UPLOAD_ORDER_STATUS = {
  ORDER_NOT_FOUND: 'Order Not Found',
  QUEUEING: 'Queueing',
  DUPLICATE_REF_NUMBER: 'Duplicate Reference No.',
};

export const LABEL_COLOR = {
  RED: 'red-tag',
  YELLOW: 'yellow-tag',
  BLUE: 'blue-tag',
  GREY: 'grey-tag',
  GREEN: 'green-tag',
};

export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const SHIPMENT_STATUS = {
  IN_TRANSIT: 'IN-TRANSIT',
  DELIVERED: 'DELIVERED',
};

export const HEARTBEAT_DEVICE = {
  MOBILE: 'MOBILE',
  GPS: 'GPS',
};

export const HERE_MAPS_API_KEY = 'BgEr8-hf2JLj3lJQ78fVj_Aft6cLHAB0wC2Q2UX_Ld8';

export const HERE_MAPS_BASE_URL =
  'https://geocode.search.hereapi.com/v1/geocode';

export const LOCAL_STORAGE_KEY = {
  USER_INFO: 'user_info',
  USER_RESTRICTIONS: 'userRestrictions',
  COUNTRY_CODE: 'countryCode',
};

export const SHIPMENT_UPLOAD = 'shipmentUPload';

export const BTN_NAMES = {
  IMPORT_SHIPMENT: 'ImportShipmentDetails',
  PLANNING_IMPORT: 'planningImportDetails',
  CHANGE_CARRIER: 'ChangeCarrier',
  MERGE_SHIPMENT: 'MergeShipment',
  SPLIT_SHIPMENT: 'SplitShipment',
  CHANGE_TIME: 'ChangeTime',
};

export const FORBIDDEN_BTNS_ON_ADJUSTMENT = [
  BTN_NAMES.CHANGE_CARRIER,
  BTN_NAMES.MERGE_SHIPMENT,
  BTN_NAMES.SPLIT_SHIPMENT,
  BTN_NAMES.CHANGE_TIME,
];
export const TRIP_PLAN_STATUS = {
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  BOOKED: 'BOOKED',
  IN_TRANSIT: 'IN-TRANSIT',
  DELIVERED: 'DELIVERED',
  DECLINED: 'DECLINED',
  FINALIZED: 'FINALIZED',
  PICKED: 'PICKED',
  DELIVERED_LATE: 'DELIVERED-LATE',
  PICKUP_FAILURE: 'PICKUP-FAILURE',
  ACCEPTED: 'ACCEPTED',
};

export const DRIVER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  HOLD: 'Hold',
};

export const DASHBOARD_LOAD_TYPE_OPTIONS = [
  { key: '', value: '-Select-' },
  { key: 'CY', value: 'CY' },
  { key: 'FIELD_CONSOLIDATION', value: 'FIELD_CONSOLIDATION' },
  { key: 'CY_TOP_OFF', value: 'CY_TOP_OFF' },
  { key: 'PURE_CFS', value: 'PURE_CFS' },
  { key: 'MILK_RUN', value: 'MILK_RUN' },
];

export const ACTION_BUTTON = {
  FINALIZE: 'finalize',
  DELETE: 'delete',
  TENDER: 'tender',
  UNFINALIZE: 'unfinalize',
  UNASSIGN: 'unassign',
  ACCEPT: 'accept',
  DECLINE: 'decline',
};

/** Shipment detail route: query param indicating entry dashboard (UWP-53142). */
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_QUERY_PARAM = 'dashboardSource';
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_CARRIER_BOOKING =
  'carrierBooking';
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_ENROUTE_DISPATCH =
  'enrouteDispatch';
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_SHIPMENT_PLANNING =
  'shipmentPlanning';
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_SHIPMENT_EXECUTION =
  'shipmentExecution';
export const SHIPMENT_DETAIL_DASHBOARD_SOURCE_FINALIZED_SHIPMENT =
  'finalizedShipment';

export const QUALIFICATION_TYPE = {
  DRIVING_LICENSE: 'Driving License',
  LOCATION_CERTIFIED: 'Location Certified',
};

export const LOAD_POSITION = {
  HEAD: 'HEAD',
  TAIL: 'TAIL',
} as const;

export const screenName = {
  TRIP_PLANNING: 'trip-planning',
  CAREER_TRIP_BOOKING: 'career-trip-booking',
};

export const DISABLED_OPTION_LIST = [
  { key: 'P', value: 'Disabled for pickup only' },
  { key: 'D', value: 'Disabled for delivery only' },
  { key: 'B', value: 'Disabled for both pickup and delivery' },
  { key: 'X', value: 'Enabled for both' },
];

export const timezone = {
  MYS: 'Asia/Kuala_Lumpur',
  IND: 'Asia/Kolkata',
  SGP: 'Asia/Singapore',
  PHL: 'Asia/Manila',
  ZAF: 'Africa/Johannesburg',
  JPN: 'Asia/Tokyo',
  THA: 'Asia/Bangkok',
  IDN: 'Asia/Jakarta',
  CHN: 'Asia/Shanghai',
  TWN: 'Asia/Taipei',
  VNM: 'Asia/Ho_Chi_Minh',
};
